export default (state = {}, action) => { 
  if (action.type === "set_usuario") {
 
    return {
      ...action.usuario,
    };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/utils/usuarioReducer.js